module.exports = __webpack_public_path__ + "d677d4993d4ebf2f071a0f3459f0808e.svg";